// dna_frontend/src/pages/XaXacMinh.js
import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import './LietSiManagement.css'; // Tái sử dụng CSS từ trang Quản lý Liệt sĩ

// ====================================================================
// COMPONENT 1: MODAL XÁC MINH "CHƯA RÕ XÃ"
// ====================================================================
const ChuaRoXaModal = ({ open, onClose, task, onTaskSubmit }) => {
    const [xacNhan, setXacNhan] = useState('chua_chon');
    const [ghiChu, setGhiChu] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) {
            // Reset khi mở modal
            setXacNhan(task.xa_xac_nhan || 'chua_chon');
            setGhiChu(task.xa_ghi_chu || '');
            setError('');
        }
    }, [open, task]);

    const handleSubmit = async () => {
        if (xacNhan === 'chua_chon') {
            setError('Vui lòng chọn "Xác nhận" hoặc "Từ chối".');
            return;
        }
        setLoading(true);
        setError('');
        try {
            await api.post('/xacminh/xa/submit-chuaroxa', {
                mapping_id: task.mapping_id,
                xa_xac_nhan: xacNhan,
                xa_ghi_chu: ghiChu
            });
            onTaskSubmit(); // Gọi lại hàm cha để tải lại danh sách
            onClose();
        } catch (err) {
            setError(err.response?.data?.message || 'Lỗi khi gửi xác nhận');
        } finally {
            setLoading(false);
        }
    };

    if (!open) return null;

    return (
        <div className="modal-backdrop">
            <div className="modal-content" style={{ width: '600px' }}>
                <h3>Xác minh Thân nhân (Chưa rõ xã)</h3>
                <p>Vui lòng xác minh thông tin cho thân nhân:</p>
                <div className="info-box">
                    <strong>Họ tên:</strong> {task.ho_ten} <br />
                    <strong>Năm sinh:</strong> {task.nam_sinh} <br />
                    <strong>CCCD:</strong> {task.cccd} <br />
                    <strong>Địa chỉ (gốc):</strong> {task.dia_chi} <br />
                    <strong>Admin ghi chú:</strong> {task.admin_ghi_chu}
                </div>
                
                {error && <p className="modal-error">{error}</p>}
                
                <div className="form-group">
                    <label>Kết quả xác minh của Xã (*)</label>
                    <select value={xacNhan} onChange={(e) => setXacNhan(e.target.value)}>
                        <option value="chua_chon">-- Vui lòng chọn --</option>
                        <option value="xac_nhan">Xác nhận (Là thân nhân của xã)</option>
                        <option value="tu_choi">Từ chối (Không phải thân nhân của xã)</option>
                    </select>
                </div>
                <div className="form-group">
                    <label>Ghi chú của Xã</label>
                    <textarea 
                        value={ghiChu} 
                        onChange={(e) => setGhiChu(e.target.value)}
                        placeholder="Nhập ghi chú (nếu có)..."
                    />
                </div>
                
                <div className="modal-actions">
                    <button type="button" onClick={onClose} className="btn-secondary">Hủy</button>
                    <button type="button" onClick={handleSubmit} className="btn-primary" disabled={loading}>
                        {loading ? 'Đang gửi...' : 'Gửi Xác Nhận'}
                    </button>
                </div>
            </div>
        </div>
    );
};

// ====================================================================
// COMPONENT 2: MODAL XÁC MINH "TRÙNG LẶP"
// ====================================================================
const TrungLapModal = ({ open, onClose, task, onTaskSubmit }) => {
    const [ghiChu, setGhiChu] = useState('');
    const [lietSiTamList, setLietSiTamList] = useState([]);
    const [newLietSi, setNewLietSi] = useState({ ho_ten_ls: '', loai_quan_he: '', stt_than_nhan: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) {
            setGhiChu(task.xa_ghi_chu || '');
            setLietSiTamList([]); // Tạm thời reset, (sẽ nâng cấp sau để tải ls tạm đã lưu)
            setNewLietSi({ ho_ten_ls: '', loai_quan_he: '', stt_than_nhan: '' });
            setError('');
        }
    }, [open, task]);

    const handleAddLietSi = () => {
        if (!newLietSi.ho_ten_ls || !newLietSi.loai_quan_he || !newLietSi.stt_than_nhan) {
            setError('Vui lòng nhập đủ Họ tên LS, Quan hệ và STT.');
            return;
        }
        setError('');
        setLietSiTamList([...lietSiTamList, newLietSi]);
        setNewLietSi({ ho_ten_ls: '', loai_quan_he: '', stt_than_nhan: '' }); // Reset form
    };
    
    const handleRemoveLietSi = (index) => {
        setLietSiTamList(lietSiTamList.filter((_, i) => i !== index));
    };

    const handleNewLSDChange = (e) => {
        setNewLietSi({ ...newLietSi, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        setLoading(true);
        setError('');
        try {
            await api.post('/xacminh/xa/submit-trunglap', {
                mapping_id: task.mapping_id,
                xa_ghi_chu: ghiChu,
                liet_si_tam_list: lietSiTamList // Gửi danh sách LS tạm
            });
            onTaskSubmit();
            onClose();
        } catch (err) {
            setError(err.response?.data?.message || 'Lỗi khi gửi xác nhận');
        } finally {
            setLoading(false);
        }
    };

    if (!open) return null;

    return (
        <div className="modal-backdrop">
            <div className="modal-content" style={{ width: '800px' }}>
                <h3>Xác minh Thân nhân (Trùng lặp)</h3>
                
                <div className="info-grid">
                    <div className="info-box">
                        <strong>Thông tin Thân nhân cần xác minh:</strong><br />
                        <strong>Họ tên:</strong> {task.ho_ten} <br />
                        <strong>Năm sinh:</strong> {task.nam_sinh} <br />
                        <strong>CCCD:</strong> {task.cccd} <br />
                        <strong>Địa chỉ (gốc):</strong> {task.dia_chi}
                    </div>
                    <div className="info-box warning">
                        <strong>Thông tin gốc (Admin):</strong><br />
                        {task.admin_ghi_chu} <br />
                        <strong>LS liên quan (gốc):</strong><br />
                        {task.liet_si_info_goc || '(Không có)'}
                    </div>
                </div>

                <hr />
                
                <h4>Thông tin Liệt sĩ (do Xã xác minh)</h4>
                <p>Vui lòng thêm tất cả Liệt sĩ có liên quan đến thân nhân này.</p>
                
                {/* Form thêm LS tạm */}
                <div className="add-ls-form">
                    <input 
                        type="text" 
                        name="ho_ten_ls" 
                        placeholder="Họ tên Liệt sĩ" 
                        value={newLietSi.ho_ten_ls} 
                        onChange={handleNewLSDChange} 
                    />
                    <select name="loai_quan_he" value={newLietSi.loai_quan_he} onChange={handleNewLSDChange}>
                        <option value="">-- Loại Quan hệ --</option>
                        <option value="1">Vợ/Chồng</option>
                        <option value="2">Con</option>
                        <option value="3">Bố/Mẹ</option>
                        <option value="4">Anh/Chị/Em ruột</option>
                        <option value="5">Người thờ cúng</option>
                        <option value="6">Khác</option>
                    </select>
                    <select name="stt_than_nhan" value={newLietSi.stt_than_nhan} onChange={handleNewLSDChange}>
                        <option value="">-- STT --</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="du_phong">Dự phòng (3, 4...)</option>
                    </select>
                    <button type="button" onClick={handleAddLietSi} className="btn-success">Thêm LS</button>
                </div>
                
                {/* Danh sách LS tạm đã thêm */}
                <div className="table-wrapper-modal">
                    <table className="crud-table">
                        <thead>
                            <tr>
                                <th>Họ tên Liệt sĩ</th>
                                <th>Quan hệ</th>
                                <th>STT</th>
                                <th>Xóa</th>
                            </tr>
                        </thead>
                        <tbody>
                            {lietSiTamList.length === 0 && (
                                <tr><td colSpan="4" style={{textAlign: 'center'}}>Chưa thêm liệt sĩ nào</td></tr>
                            )}
                            {lietSiTamList.map((ls, index) => (
                                <tr key={index}>
                                    <td>{ls.ho_ten_ls}</td>
                                    <td>{ls.loai_quan_he}</td>
                                    <td>{ls.stt_than_nhan}</td>
                                    <td>
                                        <button onClick={() => handleRemoveLietSi(index)} className="btn-delete-small">X</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="form-group" style={{marginTop: '15px'}}>
                    <label>Ghi chú của Xã</label>
                    <textarea 
                        value={ghiChu} 
                        onChange={(e) => setGhiChu(e.target.value)}
                        placeholder="Ghi chú thêm (nếu cần)..."
                    />
                </div>

                {error && <p className="modal-error">{error}</p>}

                <div className="modal-actions">
                    <button type="button" onClick={onClose} className="btn-secondary">Hủy</button>
                    <button type="button" onClick={handleSubmit} className="btn-primary" disabled={loading}>
                        {loading ? 'Đang gửi...' : 'Gửi Xác Nhận'}
                    </button>
                </div>
            </div>
        </div>
    );
};


// ====================================================================
// COMPONENT CHÍNH: TRANG XÁC MINH
// ====================================================================
function XaXacMinh() {
    const [chuaRoXaTasks, setChuaRoXaTasks] = useState([]);
    const [trungLapTasks, setTrungLapTasks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // State cho Modal
    const [modalType, setModalType] = useState(null); // 'chuaroxa' or 'trunglap'
    const [selectedTask, setSelectedTask] = useState(null);

    // Hàm tải dữ liệu
    const fetchTasks = useCallback(async () => {
        setLoading(true);
        setError('');
        try {
            // API lấy tất cả nhiệm vụ cho xã
            const res = await api.get('/xacminh/xa/all-tasks'); 
            setChuaRoXaTasks(res.data.chuaRoXa);
            setTrungLapTasks(res.data.trungLap);
        } catch (err) {
            setError(err.response?.data?.message || 'Lỗi tải danh sách nhiệm vụ');
        } finally {
            setLoading(false);
        }
    }, []);

    // Tải dữ liệu khi component mount
    useEffect(() => {
        fetchTasks();
    }, [fetchTasks]);

    // Xử lý mở Modal
    const handleOpenModal = (task, type) => {
        setSelectedTask(task);
        setModalType(type);
    };

    // Xử lý đóng Modal
    const handleCloseModal = () => {
        setSelectedTask(null);
        setModalType(null);
    };

    // Hàm callback khi submit modal thành công
    const handleTaskSubmit = () => {
        fetchTasks(); // Tải lại toàn bộ danh sách
    };

    if (loading) {
        return <div className="liet-si-container"><p>Đang tải danh sách nhiệm vụ...</p></div>;
    }
    
    if (error) {
         return <div className="liet-si-container"><p className="error-message">{error}</p></div>;
    }

    return (
        <div className="liet-si-container">
            <h1>Nhiệm vụ Xác minh Thông tin</h1>

            {/* --- DANH SÁCH 1: CHƯA RÕ XÃ --- */}
            <div className="list-section">
                <h2>1. Thân nhân cần xác minh (Chưa rõ xã)</h2>
                {chuaRoXaTasks.length === 0 ? (
                    <p>Không có nhiệm vụ nào.</p>
                ) : (
                    <div className="table-wrapper">
                        <table className="crud-table">
                            <thead>
                                <tr>
                                    <th>Họ tên</th>
                                    <th>Năm sinh</th>
                                    <th>CCCD</th>
                                    <th>Địa chỉ (gốc)</th>
                                    <th>Admin ghi chú</th>
                                    <th>Trạng thái (Xã)</th>
                                    <th>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {chuaRoXaTasks.map(task => (
                                    <tr key={task.mapping_id}>
                                        <td>{task.ho_ten}</td>
                                        <td>{task.nam_sinh}</td>
                                        <td>{task.cccd}</td>
                                        <td>{task.dia_chi}</td>
                                        <td>{task.admin_ghi_chu}</td>
                                        <td>
                                            {task.xa_xac_nhan === 'xac_nhan' && <span style={{color: 'green'}}>Đã xác nhận</span>}
                                            {task.xa_xac_nhan === 'tu_choi' && <span style={{color: 'red'}}>Đã từ chối</span>}
                                            {task.xa_xac_nhan !== 'xac_nhan' && task.xa_xac_nhan !== 'tu_choi' && <span style={{color: 'gray'}}>Chờ xác minh</span>}
                                        </td>
                                        <td>
                                            <button 
                                                className="btn-edit"
                                                onClick={() => handleOpenModal(task, 'chuaroxa')}
                                            >
                                                Xác minh
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* --- DANH SÁCH 2: TRÙNG LẶP --- */}
            <div className="list-section" style={{marginTop: '30px'}}>
                <h2>2. Thân nhân cần xác minh (Trùng lặp)</h2>
                 {trungLapTasks.length === 0 ? (
                    <p>Không có nhiệm vụ nào.</p>
                ) : (
                    <div className="table-wrapper">
                        <table className="crud-table">
                            <thead>
                                <tr>
                                    <th>Họ tên</th>
                                    <th>Năm sinh</th>
                                    <th>CCCD</th>
                                    <th>Thông tin gốc (Admin)</th>
                                    <th>Trạng thái (Xã)</th>
                                    <th>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {trungLapTasks.map(task => (
                                    <tr key={task.mapping_id}>
                                        <td>{task.ho_ten}</td>
                                        <td>{task.nam_sinh}</td>
                                        <td>{task.cccd}</td>
                                        <td>{task.liet_si_info_goc || task.admin_ghi_chu}</td>
                                        <td>
                                            {task.xa_xac_nhan === 'da_xac_nhan' ? <span style={{color: 'green'}}>Đã xác nhận</span> : <span style={{color: 'gray'}}>Chờ xác minh</span>}
                                        </td>
                                        <td>
                                            <button 
                                                className="btn-edit"
                                                onClick={() => handleOpenModal(task, 'trunglap')}
                                            >
                                                Xác minh
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Render Modals */}
            <ChuaRoXaModal 
                open={modalType === 'chuaroxa'}
                onClose={handleCloseModal}
                task={selectedTask}
                onTaskSubmit={handleTaskSubmit}
            />
            
            <TrungLapModal
                open={modalType === 'trunglap'}
                onClose={handleCloseModal}
                task={selectedTask}
                onTaskSubmit={handleTaskSubmit}
            />
        </div>
    );
}

export default XaXacMinh;